import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=5c833af0&scoped=true&lang=pug&"
import script from "./HeaderComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=5c833af0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c833af0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c833af0')) {
      api.createRecord('5c833af0', component.options)
    } else {
      api.reload('5c833af0', component.options)
    }
    module.hot.accept("./HeaderComponent.vue?vue&type=template&id=5c833af0&scoped=true&lang=pug&", function () {
      api.rerender('5c833af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderComponent.vue"
export default component.exports